import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-history" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr mt-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Seleccionar producto"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen"
    })
  ])
], -1)
const _hoisted_9 = { class: "panel-container" }
const _hoisted_10 = { class: "panel-content" }
const _hoisted_11 = { class: "form-row align-items-end" }
const _hoisted_12 = { class: "col-xl-5 col-lg-6 col-md-7 col-sm-10 col-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "id_producto"
}, "Producto", -1)
const _hoisted_14 = { class: "col-xl-2 col-lg-2 col-md-3 col-sm-4 col-6 mt-2 mt-md-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "anio"
}, "Año", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Todos", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-xl-2 col-lg-2 col-md-3 col-sm-4 col-6 mt-2 mt-md-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "mes"
}, "Mes", -1)
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Todos", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "row"
}
const _hoisted_24 = { class: "col-xl col-lg-4 col-md-4 col-sm-6 col-12" }
const _hoisted_25 = { class: "card mb-g" }
const _hoisted_26 = { class: "card-body text-center py-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mb-1" }, "Saldo Unidades", -1)
const _hoisted_28 = { class: "h4 mb-0" }
const _hoisted_29 = { class: "col-xl col-lg-4 col-md-4 col-sm-6 col-12" }
const _hoisted_30 = { class: "card mb-g" }
const _hoisted_31 = { class: "card-body text-center py-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mb-1" }, "Valor Saldo", -1)
const _hoisted_33 = { class: "h4 mb-0" }
const _hoisted_34 = { class: "col-xl col-lg-4 col-md-4 col-sm-6 col-12" }
const _hoisted_35 = { class: "card mb-g" }
const _hoisted_36 = { class: "card-body text-center py-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mb-1" }, "Ingreso Ventas", -1)
const _hoisted_38 = { class: "h4 mb-0" }
const _hoisted_39 = { class: "col-xl col-lg-4 col-md-4 col-sm-6 col-12" }
const _hoisted_40 = { class: "card mb-g" }
const _hoisted_41 = { class: "card-body text-center py-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mb-1" }, "Costo Ventas", -1)
const _hoisted_43 = { class: "h4 mb-0" }
const _hoisted_44 = { class: "col-xl col-lg-4 col-md-4 col-sm-6 col-12" }
const _hoisted_45 = { class: "card mb-g" }
const _hoisted_46 = { class: "card-body text-center py-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mb-1" }, "Utilidad Bruta", -1)
const _hoisted_48 = {
  key: 1,
  class: "row"
}
const _hoisted_49 = { class: "col-xl-12" }
const _hoisted_50 = { class: "panel" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr mt-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Historial de movimientos"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen"
    })
  ])
], -1)
const _hoisted_52 = { class: "panel-container" }
const _hoisted_53 = { class: "panel-content" }
const _hoisted_54 = { class: "text-right" }
const _hoisted_55 = { class: "text-right" }
const _hoisted_56 = { class: "text-right" }
const _hoisted_57 = { class: "text-right" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select2 = _resolveComponent("Select2")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Select2, {
                    id: "id_producto",
                    modelValue: _ctx.idProductoSeleccionado,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.idProductoSeleccionado) = $event)),
                    options: _ctx.productos,
                    onSelect: _ctx.onProductoSeleccionado,
                    settings: { multiple: false, placeholder: 'Buscar producto...', width: '100%', tags: false }
                  }, null, 8, ["modelValue", "options", "onSelect", "settings"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("select", {
                    id: "anio",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anioFiltro) = $event)),
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFiltroFecha && _ctx.onFiltroFecha(...args)))
                  }, [
                    _hoisted_16,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anios, (a) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: a,
                        value: a
                      }, _toDisplayString(a), 9, _hoisted_17))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.anioFiltro]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("select", {
                    id: "mes",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mesFiltro) = $event)),
                    disabled: _ctx.anioFiltro === 0,
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFiltroFecha && _ctx.onFiltroFecha(...args)))
                  }, [
                    _hoisted_21,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meses, (m) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: m.valor,
                        value: m.valor
                      }, _toDisplayString(m.nombre), 9, _hoisted_22))
                    }), 128))
                  ], 40, _hoisted_20), [
                    [_vModelSelect, _ctx.mesFiltro]
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.resumen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.numeral(_ctx.resumen.saldo_unidades).format('0,0.00')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.numeral(_ctx.resumen.valor_saldo).format('0,0.00')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.numeral(_ctx.resumen.ingreso_ventas).format('0,0.00')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.numeral(_ctx.resumen.costo_ventas).format('0,0.00')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", {
                  class: _normalizeClass(["h4 mb-0", Number(_ctx.resumen.utilidad_bruta) >= 0 ? 'text-success' : 'text-danger'])
                }, _toDisplayString(_ctx.numeral(_ctx.resumen.utilidad_bruta).format('0,0.00')), 3)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.idProductoStockActual)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_EasyDataTable, {
                    "server-options": _ctx.serverOptions,
                    "onUpdate:serverOptions": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.serverOptions) = $event)),
                    "server-items-length": _ctx.totalItems,
                    loading: _ctx.loading,
                    headers: _ctx.headers,
                    items: _ctx.movimientos,
                    "border-cell": "",
                    alternating: "",
                    "buttons-pagination": ""
                  }, {
                    "item-tipo_movimiento": _withCtx((item) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", item.tipo_movimiento === 'entrada' ? 'badge-success' : 'badge-danger'])
                      }, _toDisplayString(item.tipo_movimiento === 'entrada' ? 'Entrada' : 'Salida'), 3)
                    ]),
                    "item-concepto": _withCtx((item) => [
                      _createTextVNode(_toDisplayString(_ctx.descripcionConcepto(item.concepto)), 1)
                    ]),
                    "item-movimiento": _withCtx((item) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-right", item.tipo_movimiento === 'entrada' ? 'text-success' : 'text-danger'])
                      }, _toDisplayString(item.tipo_movimiento === 'entrada' ? '+' : '-') + _toDisplayString(_ctx.numeral(item.movimiento).format('0,0.00')), 3)
                    ]),
                    "item-precio_costo_unitario": _withCtx((item) => [
                      _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.numeral(item.precio_costo_unitario).format('0,0.00')), 1)
                    ]),
                    "item-costo_total": _withCtx((item) => [
                      _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.numeral(item.costo_total).format('0,0.00')), 1)
                    ]),
                    "item-saldo_unidades": _withCtx((item) => [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.numeral(item.saldo_unidades).format('0,0.00')), 1)
                      ])
                    ]),
                    "item-saldo_valor": _withCtx((item) => [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.numeral(item.saldo_valor).format('0,0.00')), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["server-options", "server-items-length", "loading", "headers", "items"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_58
  ]))
}